/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useCallback} from 'react'
import { useTranslation } from 'react-i18next'

import { FaCheck, FaTrashAlt } from 'react-icons/fa'

import {
  Button,
  Tooltip,
  useTheme,
} from '@mui/material'

import { IColumn } from 'types'
import { usePATCH_groupCourseMutation } from 'redux/api/groupCoursesApi'
import { actionIcon, pencilIcon } from 'utils/customizedTheme'

export const useTableModel = () => {

  const { t } = useTranslation()

  const handleStatusFormat = useCallback(
    (cellValue: string) => (cellValue ? t(`enrollment-status.${cellValue.toLowerCase()}`) : ''),
    [],
  )

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <Actions row={row} index={index} /> ,
    [],
  )

  const columns: IColumn[] = [

    {
      title: `${t('common.status')}`,
      field: 'status',
      order: true,
      width: '10%',
      format: handleStatusFormat,
    },
    {
      title: `${t('common.group')}`,
      field: 'group',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.course')}`,
      field: 'course',
      order: true,
      width: '30%',
    },
    {
      title: `${t('school.academic-periods')}`,
      field: 'academic_periods',
      order: true,
      width: '25%',  
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}

interface IProps {
  row: any
  index: number
}

const Actions: FC<IProps> = memo(({ row }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [setGroupCourseStatus] = usePATCH_groupCourseMutation()
  
  return (
    <>
      {row.actions?.is_editable && (   
        <Tooltip title={  row.status !== 'active'  ? `${t('common.activate')}` : `${t('common.unenroll')}`} arrow placement='top'>
          <Button
            onClick={() => {

                setGroupCourseStatus({
                  id: row.id, 
                  body: { status: row.status === 'active' ? 'cancelled' : 'active' }
                })

              }
            }
            variant='outlined'
            color='error'
            disableElevation
            sx={{ ...actionIcon, ...pencilIcon }}
          > 
            { row.status !== 'active' ? <FaCheck/> : <FaTrashAlt />  }
          </Button>
        </Tooltip>
      )}
    </>
  )
})
